import { motion } from "framer-motion";
import { MapPin, Phone, Clock } from "lucide-react";
import { COMPANY, LOCATIONS } from "@/components/laneeka/data";

export default function FootMapPage() {
  return (
    <main data-testid="footmap-page" className="pt-[108px]">
      <section className="bg-slate-50 border-b border-slate-200 py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <p className="text-xs font-semibold uppercase tracking-widest text-blue-700 mb-3">About</p>
          <h1 className="text-3xl sm:text-4xl font-bold tracking-tight text-slate-900">Our foot map</h1>
          <p className="mt-3 text-slate-600 max-w-2xl">
            Our foot map provides a detailed overview of our facilities, helping you easily reach the right
            department — whether you're a visitor or a partner.
          </p>
        </div>
      </section>

      <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid lg:grid-cols-2 gap-10">
          <div className="space-y-5">
            {LOCATIONS.map((loc, i) => (
              <motion.div
                key={loc.label}
                data-testid={`location-card-${i}`}
                initial={{ opacity: 0, y: 16 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: i * 0.08 }}
                className="border border-slate-200 rounded-xl p-6"
              >
                <p className="text-xs font-semibold uppercase tracking-widest text-blue-700 mb-2">{loc.label}</p>
                <p className="flex items-start gap-2.5 text-slate-900 font-medium leading-relaxed">
                  <MapPin className="w-5 h-5 text-blue-700 mt-0.5 shrink-0" strokeWidth={1.75} />
                  {loc.address}
                </p>
                <div className="mt-4 pl-7 space-y-1.5 text-sm text-slate-600">
                  <p className="flex items-center gap-2"><Phone className="w-4 h-4" /> {COMPANY.phone}</p>
                  <p className="flex items-center gap-2"><Clock className="w-4 h-4" /> {COMPANY.hours}</p>
                </div>
              </motion.div>
            ))}
          </div>
          <motion.div
            initial={{ opacity: 0, y: 16 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5, delay: 0.1 }}
            className="rounded-xl overflow-hidden border border-slate-200 min-h-[320px]"
            data-testid="footmap-map"
          >
            <iframe
              title="Laneeka International locations — Dhaka"
              src="https://maps.google.com/maps?q=Nikunja%202%2C%20Khilkhet%2C%20Dhaka%201229%2C%20Bangladesh&t=&z=13&ie=UTF8&iwloc=&output=embed"
              className="w-full h-full min-h-[320px]"
              loading="lazy"
            />
          </motion.div>
        </div>
      </section>
    </main>
  );
}
